(function () {
    'use strict';
    var controllerId = 'convalidaAdes';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'adesione', convalidaAdes]);

    function convalidaAdes($scope, datacontext, sectionMenu, $uibModalInstance, adesione) {
        $scope.adesione = jQuery.extend({}, adesione); //Clona oggetto
        $scope.adesione.bConvalida = true;
        $scope.isOkISEE = 0;
        $scope.adesione.ConfirmISEE = '';

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1)
                $scope.opened1 = true;
        };

        $scope.ok = function (isValid) {
            if (isValid) {

                if ($scope.isOkISEE == 0 || ($scope.isOkISEE == 2 && $scope.adesione.ConfirmISEE == ''))
                    return;

                if ($scope.isOkISEE == 1)
                    $scope.adesione.ConfirmISEE = $scope.adesione.Dich2_04_ISEE;

                var result = addItem($scope.adesione);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.CNDAdesione_setStatus(item).then(function (data) {
                return data;
            });
        }

    }
})();